import { render, staticRenderFns } from "./MitAdminSpacesUploadPage.vue?vue&type=template&id=dc1a1578&scoped=true"
import script from "./MitAdminSpacesUploadPage.vue?vue&type=script&lang=js"
export * from "./MitAdminSpacesUploadPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminSpacesUploadPage.vue?vue&type=style&index=0&id=dc1a1578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a1578",
  null
  
)

export default component.exports